import { createStore } from 'vuex'
import system, { SystemState } from '@/store/modules/system'
import accounts, { AccountState } from '@/store/modules/accounts'
import pageHelper, { PageHelperState } from '@/store/modules/pageHelper'

export interface RootState {
  system: SystemState
  accounts: AccountState
  pageHelper: PageHelperState
}

const store = createStore({
  modules: {
    system,
    accounts,
    pageHelper,
  },
})

export default store
